import {isDev, isStaging, isProduction, isLocal} from '@shared-utils/helpers'

const ensureTrailingSlash = url => {
  return url.endsWith('/') ? url : `${url}/`
}

const getEnvPrefix = () => {
  if (isProduction()) return 'PROD'
  if (isStaging()) return 'STAGING'
  if (isDev()) return 'DEV'
  if (isLocal()) return 'LOCAL'

  throw new Error('[shared-utils] Unknown VUE_APP_ENV')
}

const getAppUrl = app => {
  const prefix = getEnvPrefix()
  const key = `VUE_APP_${prefix}_${app.toUpperCase()}_URL`

  const url = process.env[key]

  if (!url) {
    throw new Error(`[shared-utils] Missing env variable ${key}`)
  }

  return ensureTrailingSlash(url)
}

export const oldDomains = [
  'login-dev.point2web.com',
  'dev-my-agency.point2web.com',
  'staging-my-agency.point2web.com',
  'my-agency.point2web.com',
]

export const checkAliasAndGetUrl = redirectUrl => {
  if (!redirectUrl) {
    return ''
  }
  const currentUrl = new URL(redirectUrl)

  if (!oldDomains.includes(currentUrl.hostname)) {
    return currentUrl
  }

  const base = AppUrls.crm()

  const path = currentUrl.pathname === '/login' ? '' : currentUrl.pathname + currentUrl.search

  return new URL(path, base).toString()
}

export const AppUrls = {
  login: () => getAppUrl('login'),
  client: () => getAppUrl('client'),
  crm: () => getAppUrl('crm'),
}

export function getImpersonationTargetBaseUrl(origin) {
  const key = String(origin ?? '').toLowerCase()
  if (key === 'crm') {
    return AppUrls.crm()
  }
  if (key === 'app' || key === 'client') {
    return AppUrls.client()
  }
  throw new Error(`[shared-utils] Unknown impersonation origin: ${origin}`)
}
